import { defineComponent } from 'vue'
import UserEvent from '../objects/UserEvent'

interface Data {
    logPersistInterval: number | null
}

export default defineComponent({
    data(): Data {
        return {
            logPersistInterval: null,
        }
    },
    mounted() {
        this.startLogPersistInterval()
    },
    beforeUnmount() {
        this.stopLogPersistInterval()
    },
    methods: {
        startLogPersistInterval() {
            this.stopLogPersistInterval()
            this.logPersistInterval = window.setInterval(this.logPersistTime, 1000)
        },
        stopLogPersistInterval() {
            if (this.logPersistInterval) {
                window.clearInterval(this.logPersistInterval)
                this.logPersistInterval = null
            }
        },
        async logPersistTime() {
            if (!window.browser_id) return

            let landingInfo = { [window.browser_id]: { landingInMili: Date.now(), persistInSec: 0 } }
            try {
                const storedInfo = localStorage.getItem('MWM_LANDING_INFO')
                if (storedInfo) {
                    landingInfo = JSON.parse(storedInfo)
                }
            } catch (error) {
                landingInfo = { [window.browser_id]: { landingInMili: Date.now(), persistInSec: 0 } }
            }

            let landingInMili = landingInfo[window.browser_id]?.landingInMili || Date.now()
            let persistInSec = landingInfo[window.browser_id]?.persistInSec || 0

            if (new Date(landingInMili).getDate() !== new Date().getDate()) {
                landingInMili = Date.now()
                persistInSec = 0
            }

            landingInfo[window.browser_id] = { landingInMili, persistInSec }
            const durationInSec = Math.floor((Date.now() - landingInMili) / 1000)
            if (
                (persistInSec < 30 && durationInSec >= 30) ||
                (persistInSec < 120 && durationInSec >= 120) ||
                (persistInSec < 300 && durationInSec >= 300) ||
                (persistInSec < 600 && durationInSec >= 600) ||
                (persistInSec < 900 && durationInSec >= 900) ||
                (persistInSec < 1800 && durationInSec >= 1800)
            ) {
                await this.postPersistTime(durationInSec)
                landingInfo[window.browser_id].persistInSec = durationInSec
            }

            try {
                localStorage.setItem('MWM_LANDING_INFO', JSON.stringify(landingInfo))
            } catch (error) {
                console.error('Error saving landing info to localStorage:', error)
            }
        },
        async postPersistTime(durationInSec: number) {
            await this.$logTrackingEvent(UserEvent.PERSIST, undefined, false, false, { duration: durationInSec })
        },
        async logNavigation(page: string) {
            await this.$logTrackingEvent(UserEvent.NAVIGATE, undefined, false, false, { page })
        },
        async logNavigateForPayment(page: string) {
            if (['worksheet', 'bingo', 'flashcard'].includes(page)) {
                page = 'make a ' + page
            } else if (page === 'account') {
                page = 'my account'
            }
            await this.$logTrackingEvent(UserEvent.NAVIGATE_FOR_PAYMENT, undefined, false, false, { page })
        },
        async logChoosePlan(period: string, trial: string, planType: string, page: string) {
            await this.$logTrackingEvent(UserEvent.CHOOSE_PLAN, page, false, false, { period, trial, planType, page })
        },
        async logPaymentSubmittion(period: string, trial: string, planType: string, page: string) {
            await this.$logTrackingEvent(UserEvent.PAYMENT_SUBMISSION, undefined, false, false, {
                period,
                trial,
                planType,
                page,
            })
        },
        async logPaymentSuccess(period: string, trial: string, planType: string, page: string) {
            await this.$logTrackingEvent(UserEvent.PAYMENT_SUCCESS, undefined, false, false, {
                period,
                trial,
                planType,
                page,
            })
        },
        async logFreeSubscriptionSignup(page: string) {
            await this.$logTrackingEvent(UserEvent.FREE_SUBSCRIPTION_SIGNUP, undefined, false, false, { page })
        },
        async logNewSignUp(page: string = 'account') {
            await this.$logTrackingEvent(UserEvent.NEW_USER_SIGNUP, undefined, false, false, {
                page,
                authMethod: 'manual',
                authType: 'create account',
            })
        },
        async logClickMakePrintable(page: string) {
            await this.$logTrackingEvent(UserEvent.PUBLISH_BUTTON_CLICK, undefined, false, false, { page })
        },
        async logSocialAuthAttempt(authType: string = 'login') {
            await this.$logTrackingEvent(UserEvent.AUTHENTICATION_ATTEMPTED, undefined, false, false, {
                authMethod: 'google',
                authType,
            })
        },
    },
})

export const getEntityStatsigValue = (entity: string) => {
    let title = 'Worksheet'
    switch (entity) {
        case 'bingo':
            title = 'Bingo Cards'
            break
        case 'flashcard':
            title = 'Flashcards'
            break
        default:
            break
    }

    return title
}
